import { Carrier } from '../Carrier';
import { ClientContact } from '../ClientContact';
import { Contact } from '../Contact';
import { RateQuote } from '../rate/RateQuote';
import { ShipmentEvent } from '../shipmentEvent/ShipmentEvent';
import { ShipmentServiceIncident } from '../shipmentEvent/ShipmentServiceIncident';
import { TenderRequest } from '../tender/TenderRequest';

import { Shipment } from './Shipment';

export class CarrierShipmentSummary {
  shipment?: Shipment;
  carrier?: Carrier;
  acceptedRateQuote?: RateQuote;
  tenderRequest?: TenderRequest;
  errorMessage?: string;
  tenderResponseMessage?:
    | 'SHIPMENT_INACTIVE'
    | 'CANNOT_REJECT_AFTER_BOOKED'
    | 'EXCEPTION_RESPONDING'
    | 'ACCESS_DENIED'
    | 'CREDENTIALS_EXPIRED'
    | 'TENDER_NOT_FOUND'
    | 'TENDER_EXPIRED'
    | 'SUCCESS';
  communicationContacts: ClientContact[] = [];
  shipmentEvents: ShipmentEvent[] = [];
  serviceIncidents: ShipmentServiceIncident[] = [];
  shipmentEmailContact?: Contact;

  constructor(opts?: Partial<CarrierShipmentSummary>) {
    if (opts?.shipment != null) {
      this.shipment = new Shipment(opts.shipment);
    }
    if (opts?.carrier != null) {
      this.carrier = new Carrier(opts.carrier);
    }
    if (opts?.acceptedRateQuote != null) {
      this.acceptedRateQuote = new RateQuote(opts.acceptedRateQuote);
    }
    if (opts?.tenderRequest != null) {
      this.tenderRequest = new TenderRequest(opts.tenderRequest);
    }
    if (opts?.errorMessage != null) {
      this.errorMessage = opts.errorMessage;
    }
    if (opts?.tenderResponseMessage != null) {
      this.tenderResponseMessage = opts.tenderResponseMessage;
    }
    if (opts?.communicationContacts != null) {
      this.communicationContacts = opts.communicationContacts.map(
        (val) => new ClientContact(val),
      );
    }
    if (opts?.shipmentEvents != null) {
      this.shipmentEvents = opts.shipmentEvents.map(
        (val) => new ShipmentEvent(val),
      );
    }
    if (opts?.serviceIncidents != null) {
      this.serviceIncidents = opts.serviceIncidents.map(
        (val) => new ShipmentServiceIncident(val),
      );
    }
    if (opts?.shipmentEmailContact != null) {
      this.shipmentEmailContact = opts.shipmentEmailContact;
    }
  }
}
